export enum PropertyDeviceForms {
  IdentifyDevice = 'IdentifyDevice',
  DeleteDevice = 'DeleteDevice',
}
